import React from 'react'
import filter from 'lodash/filter'
import { FlatButton, TimePicker } from 'material-ui'
import { red500 } from 'material-ui/styles/colors'
import moment from 'moment'
import Delete from 'material-ui/svg-icons/action/delete'

const daysOfWeek = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

function formatTime (date) {
  return moment(date).format('HH:mm:00')
}

function parseTime (time) {
  const [hours, minutes, seconds] = time.time_of_day.split(':')
  return moment({ hours, minutes, seconds }).toDate()
}

const styles: Record<string, React.CSSProperties> = {
  wrapper: { marginTop: '1em' },
  row: { display: 'flex', alignItems: 'center' },
  label: { width: '8em', paddingLeft: '0.5em' },
  picker: { width: '8em' },
  errorText: {
    color: red500,
    fontSize: '0.8em'
  }
}

const DeleteButton = (props) => (
  <FlatButton
    secondary
    icon={<Delete />}
    style={{ minWidth: 0 }}
    {...props}
  />
)

const Schedule = ({ label, value, errorText, onChange }) => {
  const week = daysOfWeek.reduce((schedule, day, i) => {
    const existing = value.find(v => v.day_of_week === i + 1)
    return [...schedule, existing || { day_of_week: i + 1, time_of_day: null }]
  }, [])

  function handleChange (index, date) {
    onChange(null, filter([
      ...week.slice(0, index),
      { day_of_week: index + 1, time_of_day: formatTime(date) },
      ...week.slice(index + 1)
    ], 'time_of_day'))
  }

  function handleClear (index) {
    onChange(null, filter([
      ...week.slice(0, index),
      ...week.slice(index + 1)
    ], 'time_of_day'))
  }

  return (
    <div style={styles.wrapper}>
      <label>{label}</label>
      {errorText
        ? <p style={styles.errorText}>{errorText}</p>
        : null}
      <div>
        <small>Select at least one day of the week and time of day for your comment to go out.</small>
        {week.map((schedule, i) => (
          <div key={`day-${i}`} style={styles.row}>
            <label
              htmlFor={`day-${i}-timepicker`}
              style={styles.label}
            >
              {daysOfWeek[i]}
            </label>
            <TimePicker
              id={`day-${i}-timepicker`}
              name='time'
              value={schedule.time_of_day && parseTime(schedule)}
              onChange={(e, date) => handleChange(i, date)}
              textFieldStyle={styles.picker}
              autoOk
            />
            {schedule.time_of_day
              ? <DeleteButton onClick={() => handleClear(i)} />
              : null}
          </div>
        ))}
      </div>
    </div>
  )
}

export default Schedule

Schedule.PropTypes = {
  label: React.PropTypes.string.isRequired,
  value: React.PropTypes.array,
  onChange: React.PropTypes.func.isRequired
}

// @ts-ignore
Schedule.defaultProps = {
  value: []
}
